import { render, staticRenderFns } from "./PropertyFilter.vue?vue&type=template&id=5b3807d7&"
import script from "./PropertyFilter.vue?vue&type=script&lang=js&"
export * from "./PropertyFilter.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports